import apiCall from '@/utils/api';
import qs from 'qs';

const state = {
	roster: {},
	picks: [],
	all: [],
	viewed_player: {},
	viewed_player_id: -1,
};

const mutations = {
	set_players(state, payload) {
		state.roster = payload;
	},
	set_picks(state, picks) {
		state.picks = picks;
	},
	player_picked(state, payload) {
		state.picks = [...state.picks, payload];
	},
	set_queued_players(state, payload) {
		payload.map(
			({ player_id }) => (state.roster[player_id].is_queued = true)
		);
	},
	pick_player(state, player_id) {
		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: qs.stringify({ player_id }),
			url: `api/v1/rooms/${this.state.room.id}/user_rosters/pick_player`,
		};

		apiCall(options);
	},
	set_viewed_player_id(state, player_id) {
		state.viewed_player_id = player_id;
		if (state.viewed_player_id !== state.viewed_player.id) {
			const options = {
				method: 'GET',
				url: `api/v1/players/${state.viewed_player_id}`,
			};

			apiCall(options).then(({ data }) => {
				state.viewed_player = data;
			});
		}
	},
};

const getters = {
	player_name: state => player_id => state.roster[player_id].name,
	is_picked: state => player_id =>
		state.picks.filter(pickObj => pickObj.player_id == player_id).length >
		0,
	picked_players: (state, getters, rootState) => {
		return arrayToObject(
			filterPicks(state.picks, rootState.room.all_users)
		);
	},
	current_user_players: (state, getters, rootState) => {
		return arrayToObject(
			filterPicks(
				state.picks,
				rootState.room.all_users,
				rootState.user.id
			)
		);
	},
};

const arrayToObject = array => Object.assign({}, array);

/**
 * Returns the picked players, can be filtered per user
 *
 * @param {array} picks The player_id and room_user_id of all the picks
 * @param {number} all_users All of the users in the room
 * @param {number} filtered_room_user_id Optional, used to filter down to a particular users
 * @return {array} Contains the Player and Room User of each pick for the room
 */
const filterPicks = (picks, all_users, filtered_room_user_id = null) => {
	return picks.map(({ room_user_id, player_id }) => {
		//this finds the appropriate user
		const user = all_users.find(user => {
			return user.id === (filtered_room_user_id || room_user_id);
		});
		//this pulls the player
		const player = state.roster[player_id];

		return { user, player };
	});
};

const actions = {
	restart_draft: ({ commit, state }) => {
		Object.keys(state.roster).map(player_id => {
			state.roster[player_id].picked_by_id = null;
			state.roster[player_id].picked_by_name = null;
		});
		commit('set_players', state.roster);
	},
};

export default {
	state,
	mutations,
	getters,
	actions,
};
